export const WEB_PUSH_CLICK_MESSAGE_TYPE = 'WEB_PUSH_CLICK';
export const WEB_PUSH_FOREGROUND_MESSAGE_TYPE = 'WEB_PUSH_FOREGROUND';

export type WebPushClickMessage = {
  data?: Record<string, unknown>;
  href: string;
  notification_id?: string;
  type: typeof WEB_PUSH_CLICK_MESSAGE_TYPE;
};

export type WebPushForegroundMessage = {
  type: typeof WEB_PUSH_FOREGROUND_MESSAGE_TYPE;
};

function isRecord(data: unknown): data is Record<string, unknown> {
  return typeof data === 'object' && data !== null;
}

export function isWebPushForegroundMessage(
  data: unknown
): data is WebPushForegroundMessage {
  return (
    isRecord(data) && data.type === WEB_PUSH_FOREGROUND_MESSAGE_TYPE
  );
}

export function isWebPushClickMessage(
  data: unknown
): data is WebPushClickMessage {
  if (!isRecord(data) || data.type !== WEB_PUSH_CLICK_MESSAGE_TYPE) {
    return false;
  }
  if (!('href' in data) || typeof data.href !== 'string') return false;
  if (
    'notification_id' in data &&
    data.notification_id !== undefined &&
    typeof data.notification_id !== 'string'
  ) {
    return false;
  }
  if (
    'data' in data &&
    data.data !== undefined &&
    (typeof data.data !== 'object' || data.data === null)
  ) {
    return false;
  }
  return true;
}
